var d = Object.defineProperty;
var h = (r, e, t) => e in r ? d(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var u = (r, e, t) => h(r, typeof e != "symbol" ? e + "" : e, t);
const a = "default";
function o(r) {
  return typeof r == "object" ? r : { subscribed: r };
}
class p {
  constructor(e) {
    u(this, "instance");
    this.instance = e;
  }
  /**
   * @deprecated Use `user.getAllPreferences()` instead
   */
  async getAll() {
    const e = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/preferences`
    });
    return this.handleResponse(e);
  }
  /**
   * @deprecated Use `user.getPreferences()` instead
   */
  async get(e = {}) {
    const t = e.preferenceSet || a, s = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/preferences/${t}`
    });
    return this.handleResponse(s);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async set(e, t = {}) {
    const s = t.preferenceSet || a, n = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${s}`,
      data: e
    });
    return this.handleResponse(n);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setChannelTypes(e, t = {}) {
    const s = t.preferenceSet || a, n = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${s}/channel_types`,
      data: e
    });
    return this.handleResponse(n);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setChannelType(e, t, s = {}) {
    const n = s.preferenceSet || a, c = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${n}/channel_types/${e}`,
      data: { subscribed: t }
    });
    return this.handleResponse(c);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setWorkflows(e, t = {}) {
    const s = t.preferenceSet || a, n = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${s}/workflows`,
      data: e
    });
    return this.handleResponse(n);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setWorkflow(e, t, s = {}) {
    const n = s.preferenceSet || a, c = o(t), i = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${n}/workflows/${e}`,
      data: c
    });
    return this.handleResponse(i);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setCategories(e, t = {}) {
    const s = t.preferenceSet || a, n = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${s}/categories`,
      data: e
    });
    return this.handleResponse(n);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setCategory(e, t, s = {}) {
    const n = s.preferenceSet || a, c = o(t), i = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${n}/categories/${e}`,
      data: c
    });
    return this.handleResponse(i);
  }
  handleResponse(e) {
    if (e.statusCode === "error")
      throw new Error(e.error || e.body);
    return e.body;
  }
}
export {
  p as default
};
